export default __webpack_public_path__ + "static/media/delete-outlined.d04f06b7.svg";